import Footer from "../shared/Footer";
import PageHeaderSetting from "../shared/pageHeader/PageHeaderSetting";
import SelectDropdown from "../shared/SelectDropdown";
import InputTopLabel from "../shared/InputTopLabel";
import TextAreaTopLabel from "../shared/TextAreaTopLabel";
import { FiInfo } from "react-icons/fi";
import PerfectScrollbar from "react-perfect-scrollbar";
import React, { useState, useEffect } from "react";
import { FiSave } from "react-icons/fi";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const mailEngine = [
  { value: "HPMailer", label: "HPMailer" },
  { value: "codeIgniter", label: "CodeIgniter" },
];
const mailProtocol = [
  { value: "Mail", label: "Mail" },
  { value: "SMTP", label: "SMTP" },
  { value: "Sendmail", label: "Sendmail" },
];
export const settingOptions = [
  {
    value: "yes",
    label: "Yes",
    icon: "feather-check",
    iconClassName: "text-success",
  },
  { value: "no", label: "No", icon: "feather-x", iconClassName: "text-danger" },
];

const SettingsEmailForm = () => {
  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) => translations[key] || defaultValue;

  // API tablosundaki tüm alanları tek bir state içinde tut
  const [apiSettings, setApiSettings] = useState({
    mailjet_title: "",
    mailjet_secret: "",
    mailjet_api: "",
    cdn_key: "",
    cdn_secret: "",
    cdn_endpoint: "",
    cdn_bucket: "",
    cdn_region: "",
    cdn_path: "",
    paytr_merchant_id: "",
    paytr_merchant_key: "",
    paytr_merchant_salt: "",
    paypal_api_username: "",
    paypal_api_password: "",
    paypal_api_signature: "",
    stripe_publishable_key: "",
    stripe_secret_key: "",
    receiver_email: "",
    order_email: "",
  });

  // İlk render’da verileri çek
  useEffect(() => {
    fetchApiData();
  }, []);

  // API verilerini çekme
  const fetchApiData = async () => {
    try {
      const resp = await axios.get(`${BASE_URL}/api/settings/1`); // id=1 olan kaydı alıyoruz
      console.log("Gelen API Data:", resp.data);
      setApiSettings((prevState) => ({
        ...prevState,
        ...resp.data, // API'den gelen değerleri al, boş olanları koru
      }));
    } catch (err) {
      console.error("API verisi çekme hatası:", err);
      toast.error("API ayarları alınamadı!");
    }
  };

  // Input değişikliklerini handle etme
  const handleChange = (e) => {
    const { name, value } = e.target;
    setApiSettings((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Kaydet butonuna basınca API'yi güncelle
  const handleSave = async () => {
    try {
      await axios.put(`${BASE_URL}/api/settings/1`, apiSettings);
      toast.success(getText("SUCCESS_API_UPDATED"));
      fetchApiData(); // Güncellenmiş verileri tekrar çek
    } catch (error) {
      console.error("API Bilgileri kaydedilemedi:", error);
      toast.error("Kayıt hatası oluştu!");
    }
  };

  return (
    <div className="content-area setting-form">
      <ToastContainer />
      <PerfectScrollbar>
        <PageHeaderSetting />
        <div className="content-area-body">
          <div className="card mb-0">
            <div className="card-body">
              {/* ========== ALICI E-POSTA CARD ========== */}

              <div className="mb-3">
                <label className="form-label fw-bold">
                  {getText("LABEL_RECEIVER_EMAIL")}
                </label>
                <input
                  type="email"
                  className="form-control"
                  name="receiver_email"
                  placeholder={getText("PLACEHOLDER_RECEIVER_EMAIL")}
                  value={apiSettings.receiver_email || ""}
                  onChange={handleChange}
                />
                <small className="form-text text-muted">
                  {getText("HELP_RECEIVER_EMAIL")}
                </small>
              </div>
              {/* ========== SİPARİŞ MAİLİ (MAĞAZA SAHİBİ) ========== */}
              <div className="mb-3">
                <label className="form-label fw-bold">
                  {getText("LABEL_ORDER_EMAIL")}
                </label>
                <input
                  type="email"
                  className="form-control"
                  name="order_email"
                  placeholder={getText("PLACEHOLDER_ORDER_EMAIL")}
                  value={apiSettings.order_email || ""}
                  onChange={handleChange}
                />
              </div>

              {/* KAYDET BUTONU */}
              <div className="d-flex justify-content-center">
                <button className="btn btn-primary" onClick={handleSave}>
                  <FiSave className="me-2" /> {getText("SAVE_BTN")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default SettingsEmailForm;
